import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { StringInput } from "~/components";

export const InputSection: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex
      direction={{ base: "column", md: "row" }}
      gap={{ base: 4, md: 6 }}
      w="full"
    >
      <StringInput
        id="firstName"
        placeholder={t("onboarding.namePage.placeholders.firstName")}
      />
      <StringInput
        id="lastName"
        placeholder={t("onboarding.namePage.placeholders.lastName")}
      />
    </Flex>
  );
};
